/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".select-permissions-modal-container .mat-dialog-container{background-color:#fafafa}.select-permissions-modal-container select-permissions-modal{display:block}.select-permissions-modal-container select-permissions-modal .mat-accordion{display:block;margin-bottom:5px}.select-permissions-modal-container .permission-name,.select-permissions-modal-container select-permissions-modal .mat-expansion-panel-header-title{text-transform:capitalize}"];
export { styles as styles };
